import { useLocation } from "react-router-dom";
export function useQuery() {
    return new URLSearchParams(useLocation().search);
}
export function getQueryParameterName(paramName) {
    const query = useQuery();
    return query.get(paramName);
}
export function changesQueryParameter(cb, queryList) {
    let queryObj = {};
    queryList.forEach((query) => {
        queryObj = Object.assign(Object.assign({}, queryObj), query);
    });
    return cb(queryObj);
}
